import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const THREAD_CLOSED = 'THREAD_CLOSED';
const RejectedMessageAlert = ({
  rejectedMessage,
  onRefresh
}) => {
  const isThreadClosed = rejectedMessage.rejectionReason === THREAD_CLOSED;
  const title = isThreadClosed ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-visitor-ui.rejectedMessage.threadClosed"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-visitor-ui.rejectedMessage.generic"
  });
  const link = /*#__PURE__*/_jsx(VizExLink, {
    use: "on-bright",
    onPress: onRefresh,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-ui.rejectedMessage.refresh"
    })
  });
  return /*#__PURE__*/_jsx(ChatAreaAlert, {
    title: title,
    onClose: noop,
    link: link
  });
};
RejectedMessageAlert.displayName = 'RejectedMessageAlert';
export default RejectedMessageAlert;